<template>
  <v-checkbox
    :input-value="value"
    class="mt-1"
    :color="color ? color : '#FF4C00'"
    :error-messages="getErrors(validator)"
    :disabled="disabled"
    :hint="hint"
    persistent-hint
    @change="
      $emit('input', $event)
      validator && validator.$touch()
    "
    @blur="validator && validator.$touch()"
  >
    <template v-slot:label>
      <div class="label-container">
        <slot />
      </div>
    </template>
  </v-checkbox>
</template>

<script>
import { defaultMessages, getValidationErrors } from '../../../utils'

export default {
  name: 'checkbox',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
    color: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    getErrors: function (field) {
      return getValidationErrors({
        ...defaultMessages,
        ...this.errorMessages,
      })(field)
    },
  },
}
</script>

<style scoped>
.label-container {
  color: #666666;
}

.label-container >>> a {
  color: #ff4c00;
}
.label-container-zkm >>> a {
  color: #333333;
}
</style>
